export default "__VITE_ASSET__6a89c709__"